import { adminWorkspaceDeveloperQueryKeys as e } from "./useAdminWorkspaceDeveloperQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { adminWorkspaceDeveloperApi as n } from "@maat/api-main";
//#region src/workspaceDeveloper/useAdminWorkspaceDeveloperQuery.ts
var r = (r, i = !0) => t({
	queryKey: e.status(r),
	queryFn: () => n.status(r),
	enabled: i && !!r
});
//#endregion
export { r as useAdminWorkspaceDeveloperQuery };
